import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";
import { Link } from "gatsby";

function Cmsserviceworkflow() {
  return (
    <section className="cms_service_workflow p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>Advanced <span>ASO Suite</span></h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">01</div>
                <div className="cms-service-head">
                  <h5 className="lh-sm">User Sentiment <br/>Analysis</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>Analyze and categorize user reviews to uncover trends, address concerns, and boost app ratings. Enhance user experience by turning negative feedback into actionable insights.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">02</div>
                <div className="cms-service-head">
                  <h5 className="lh-sm">Reputation <br/>Management</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>Protect and enhance your app's reputation with proactive review management. Engage with users through swift responses, convert negative sentiments into positive ones, and build a loyal customer base.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">03</div>
                <div className="cms-service-head">
                  <h5 className="lh-sm">Attribution & <br/>Reporting</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>Gain clarity on ASO effectiveness with precise attribution and reporting. Understand how paid marketing, seasonality, and optimization efforts drive app growth and conversion improvements.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">04</div>
                <div className="cms-service-head">
                  <h5 className="lh-sm">Paid Search <br/>Management</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>Optimize your app’s visibility with expertly managed Apple Search Ads and Google Ads campaigns. Increase keyword rankings and downloads with data-driven strategies for cost-effective user acquisition.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">05</div>
                <div className="cms-service-head">
                  <h5 className="lh-sm">A/B Testing & <br/>Focus Groups</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>Combine A/B testing with focus groups to validate user preferences and optimize app store listings. Collect real feedback to refine your approach and maximize the impact of each test.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="cms-service-box">
              <div className="cms-service-flex">
                <div className="num">06</div>
                <div className="cms-service-head">
                  <h5 className="lh-sm">Market Research <br/>Insights</h5>
                </div>
                <div className="cms-service-icon">
                  {GenerativeAIServiceTick}
                </div>
              </div>
              <p>Stay ahead with thorough market research. Identify emerging trends, consumer behavior shifts, and algorithm updates to refine strategies and ensure your app remains competitive and up-to-date.</p>
            </div>
          </Col>
        </Row>
        {/* <Row className="mt-3 mt-md-5">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our Experts
            </Link>
          </Col>
        </Row> */}
      </Container>
    </section>
  );
}

export default Cmsserviceworkflow;
